import { isLocalHostname } from './hostname';

const BUILT_IN_CONTROL_PLANE_HOSTS = new Set([
  'app.scheduify.com',
  'booking-template-dev.web.app',
  'booking-template-dev.firebaseapp.com',
]);

const configuredControlPlaneHosts = (): Set<string> => new Set(
  (process.env.REACT_APP_CONTROL_PLANE_HOSTS ?? '')
    .split(',')
    .map((hostname) => hostname.trim().toLowerCase())
    .filter(Boolean)
);

const isDevPreviewHostname = (hostname: string): boolean => (
  process.env.REACT_APP_ENV !== 'production' &&
  /^booking-template-dev--[a-z0-9-]+\.(?:web\.app|firebaseapp\.com)$/.test(hostname)
);

export const isControlPlaneHostname = (hostnameInput: string): boolean => {
  const hostname = hostnameInput.trim().toLowerCase();
  return BUILT_IN_CONTROL_PLANE_HOSTS.has(hostname)
    || configuredControlPlaneHosts().has(hostname)
    || isDevPreviewHostname(hostname);
};

export const allowsTenantQueryOverride = (hostnameInput: string): boolean => {
  const hostname = hostnameInput.trim().toLowerCase();
  return hostname.endsWith('.localhost')
    || isLocalHostname(hostname)
    || isControlPlaneHostname(hostname);
};

export const allowsTenantlessControlPlanePath = (pathnameInput: string): boolean => {
  const pathname = pathnameInput.trim().toLowerCase().replace(/\/+$/, '') || '/';
  if (pathname === '/admin' || pathname === '/reset-password') return true;
  if (pathname === '/admin/superadmin/site') return false;
  return pathname === '/admin/superadmin' || pathname.startsWith('/admin/superadmin/');
};
